import React, { useEffect, useState } from "react";

import "./stylesPurchasesByType.css";
import ChartDataLabels from "chartjs-plugin-datalabels";

import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  BarElement,
  LineElement,
} from "chart.js";
import RebetLoader from "../../../CommonComponents/RebetLoader/RebetLoader";
import CustomDatePicker from "../../../CommonComponents/CustomDatePicker/CustomDatePicker";
import { AppStrings } from "../../../../utils/constants/AppStrings";
import { getAdminNow } from "../../../../utils/dateService";

function PurchasesByType({ isApiRunning, dashboardData }) {
  const todayRange = [getAdminNow(), getAdminNow()];

  const [sportsBookDates, setSportsBookDates] = useState(todayRange);

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
  );

  const backgroundColorOptions = [
    "#F39C12",
    "#9B59B6",
    "#E74C3C",
    "#BF3880",
    "#3498DB",
    "#E74C3C",
  ];

  const borderColorOptions = [
    "#F39C12",
    "#9B59B6",
    "#E74C3C",
    "#BF3880",
    "#3498DB",
    "#E74C3C",
  ];

  const PurchasesByTypeData = {
    [AppStrings.PURCHASE_MATCH]: dashboardData?.purchases_by_type?.purchase_match || 0,
    [AppStrings.FREE_BETS]: dashboardData?.purchases_by_type?.free_bet || 0,
    [AppStrings.FREE_SQUARES]: dashboardData?.purchases_by_type?.free_squares || 0,
    [AppStrings.PROFIT_BOOST]: dashboardData?.purchases_by_type?.profit_boost || 0,
    [AppStrings.INSURANCE_BETS]: dashboardData?.purchases_by_type?.insurance_bets || 0,
  };

  const keys = Object.keys(PurchasesByTypeData);
  const values = Object.values(PurchasesByTypeData);

  const data = {
    labels: keys,
    datasets: [
      {
        data: values,
        backgroundColor: backgroundColorOptions,
        borderColor: borderColorOptions,
        borderWidth: 1,
        borderRadius: 4,
      },
    ],
  };

  const options = {
    indexAxis: "y",
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          callback: function(value) {
            return AppStrings.COUNTRY_CURRENCY_SYMBOL + value.toLocaleString();
          }
        }
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        anchor: "end",
        align: "start",
        formatter: (value) => AppStrings.COUNTRY_CURRENCY_SYMBOL + ' ' + value.toLocaleString(),
        color: "#09090C",
        font: {
          family: "Poppins-regular",
          weight: "bold",
        },
      },
      tooltip: {
        enabled: true,
        mode: "nearest",
        intersect: false,
        backgroundColor: "#25252F",
        titleFont: {
          family: "Poppins-regular",
          size: 16,
          weight: "bold",
        },
        bodyFont: {
          family: "Poppins-regular",
          size: 14,
        },
        padding: 15,
        displayColors: true,
        callbacks: {
          label: function(context) {
            return AppStrings.COUNTRY_CURRENCY_SYMBOL + context.raw.toLocaleString();
          }
        }
      },
    },
  };

  return (
    <div id="purchases-by-type-chart">
      <div className="purchases-by-type-chart-header">
        <h3>{AppStrings.PURCHASES_BY_TYPE}</h3>
      </div>
      {isApiRunning ? (
        <RebetLoader width="100px" height="100px" />
      ) : (
        <div className="purchases-by-type-chart-body">
          <Bar data={data} options={options} />
        </div>
      )}
    </div>
  );
}

export default PurchasesByType;
